import React, { useState, useEffect } from 'react';
import { User } from 'lucide-react';
import { USER_ROLES } from '../mockData';

const RoleSelector = () => {
  const [currentRole, setCurrentRole] = useState('admin');

  useEffect(() => {
    const storedRole = localStorage.getItem('e2-user-role');
    if (storedRole) {
      setCurrentRole(storedRole);
    } else {
      localStorage.setItem('e2-user-role', 'admin');
    }
  }, []);

  const handleRoleChange = (newRole) => {
    setCurrentRole(newRole);
    localStorage.setItem('e2-user-role', newRole);
  };

  return (
    <div className="role-selector">
      <div className="role-selector-header">
        <User size={16} className="role-icon" />
        <span className="role-label">Role:</span>
      </div>
      <div className="role-buttons">
        {USER_ROLES.map(role => (
          <button
            key={role.value}
            onClick={() => handleRoleChange(role.value)}
            className={`role-button ${currentRole === role.value ? 'active' : ''}`}
          >
            {role.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default RoleSelector;
